<template>
  <button :class="{'button button__medium mb-2': !completed, edited: completed}" @click="$emit('click')">
    <template v-if="completed" class="edited">
      Edit <PencilIcon />
    </template>
    <template v-else>
      <slot />
    </template>
  </button>
</template>

<script>
import PencilIcon from "../../../icons/PencilIcon.vue";

export default {
  name: 'EventEditBtn',
  components: {PencilIcon},
  props: {
    completed: {
      required: true,
      type: Boolean,
    }
  },
}
</script>

<style scoped>
.edited {
  color: #9727C9;
}
.edited:hover {
  color: black;
}
</style>